// @ts-ignore
import { Route } from 'react-router-dom';
import Home from './components/Home/Home';
import AboutMe from './components/AboutMe/AboutMe';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Nav from './components/Nav/Nav';
import "./app.css"
import { useSelector } from 'react-redux';
import "animate.css";
import BackgroundAnimation from './components/BackgroundAnimation/BackgroundAnimation';


function App() {

  interface AppState{
    lenguage : string
    mode: string
}

  let {lenguage, mode} = useSelector((state: AppState) => state)

  return (
    <div className='appContainer' id={mode}>
      <Route path={"/"} render={()=> <Nav/> } />
      <Route exact path={"/"} render={()=> <Home/> } />
      <Route path={"/about"} render={()=> <AboutMe/> } />
      <Route path={"/skills"} render={()=> <Skills/> } />
      <Route path={"/projects"} render={()=> <Projects/> } />
      <Route path={"/contact"} render={()=> <Contact/> } />
      <BackgroundAnimation/>
      
    </div>
  );
}

export default App;
